import _ from 'lodash';
export function get_property(value,attributs='',defaultValue=''){ 
  return _.get(value,attributs) ?? defaultValue 
}